import getCustomColorPalettes from './custom-color-palettes';

const getCustomColorPalette = (state, customPaletteId) => {
  const palettes = getCustomColorPalettes(state);

  return palettes.find((customPalette) => customPalette.id === customPaletteId) || null;
};

export default getCustomColorPalette;
